import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import CTAStrip from '../../components/feature/CTAStrip';
import BookTourModal from '../../components/feature/BookTourModal';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const facilities = [
  {
    loc: '📍 Oregun, Lagos · Hub 01',
    name: 'THL Oregun Fulfillment Centre',
    sqft: '15K',
    pallets: '800',
    orders: '5,000',
    ops: '24/7',
    address: '15 Kudirat Abiola Way, Oregun, Lagos',
    features: [
      'Pick & pack for ecommerce & retail',
      'Returns processing area',
      'Container offloading & loading dock',
      'Kitting & value-added services',
      'High-velocity inventory management',
    ],
  },
  {
    loc: '📍 Iganmu, Surulere · Hub 02',
    name: 'THL Iganmu Fulfillment Centre',
    sqft: '18K',
    pallets: '950',
    orders: '6,000',
    ops: '24/7',
    address: 'Iganmu, Surulere, Lagos',
    features: [
      'Bulk retail & FMCG distribution',
      'Cross-docking & staging area',
      'Multi-channel order fulfillment',
      'Secure storage for electronics & high-value goods',
      'Last-mile dispatch coordination',
    ],
  },
];

const standards = [
  { ico: '🔒', title: '24/7 Security', desc: 'Multi-layer CCTV, biometric access, and round-the-clock security personnel.' },
  { ico: '⚡', title: 'Uninterrupted Power', desc: 'Industrial UPS and backup generators ensure zero operational downtime.' },
  { ico: '📡', title: 'Connected Infrastructure', desc: 'Fiber internet, Wi-Fi 6, and barcode scanning at every touchpoint.' },
  { ico: '📦', title: 'Scalable Setup', desc: 'Additional facilities can be configured and deployed in your preferred location based on your operational needs.' },
];

export default function FacilitiesPage() {
  const navigate = useNavigate();
  const [tourOpen, setTourOpen] = useState(false);

  return (
    <div className="min-h-screen bg-thl-dark">
      <BookTourModal open={tourOpen} onClose={() => setTourOpen(false)} />
      <Navbar />
      <div className="page-header pt-28 pb-16 px-6">
        <div className="page-header-grid" />
        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex items-center gap-2 mb-3 text-xs text-white/40">
            <button onClick={() => navigate('/')} className="hover:text-white cursor-pointer">Home</button>
            <span>/</span><span className="text-white/60">Facilities</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">Our Fulfillment Centres</h1>
          <p className="text-white/50 max-w-2xl">Two operational fulfillment centres in Lagos: <span className="text-white/70 font-medium">Oregun</span> and <span className="text-white/70 font-medium">Iganmu, Surulere</span>, with the ability to establish additional locations wherever your business requires.</p>
        </div>
      </div>

      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="eyebrow">Our Network</p>
          <h2 className="section-heading mb-2">Currently Operating in Lagos</h2>
          <p className="section-lead max-w-2xl mb-12">We currently operate two facilities across Lagos, with the flexibility to set up and manage new locations as your business scales.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {facilities.map(f => (
              <div key={f.name} className="bg-thl-dark3 border border-thl-border rounded-xl overflow-hidden hover:border-thl-red/30 transition-all">
                <div className="h-44 flex flex-col items-center justify-center gap-2 px-6 text-center" style={{ background: 'linear-gradient(135deg,#1a0a0e,#1C1C28)' }}>
                  <span className="text-white/30 text-xs">{f.loc}</span>
                  <span className="text-white font-bold text-lg">{f.name}</span>
                  <span className="text-white/40 text-xs">{f.address}</span>
                </div>
                <div className="p-6">
                  <ul className="flex flex-col gap-2 mb-5">
                    {f.features.map(ft => (
                      <li key={ft} className="flex items-center gap-2 text-white/60 text-sm"><span className="text-thl-red">✓</span>{ft}</li>
                    ))}
                  </ul>
                  <button onClick={() => setTourOpen(true)} className="btn-primary text-sm w-full">Book a Tour →</button>
                </div>
              </div>
            ))}
          </div>

          {/* Expand callout */}
          <div className="mt-10 bg-thl-dark3 border border-thl-border rounded-xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-white font-bold text-lg mb-1">Need a Facility in Your Location?</h3>
              <p className="text-white/50 text-sm max-w-lg">THL can set up and fully manage a dedicated fulfillment facility wherever you need it, tailored to your product type, volume, and operational requirements.</p>
            </div>
            <button onClick={() => navigate('/contact')} className="btn-primary text-sm whitespace-nowrap shrink-0">Talk to Us →</button>
          </div>
        </div>
      </section>

      <section className="py-20 px-6" style={{ background: '#0c0c14' }}>
        <div className="max-w-7xl mx-auto">
          <p className="eyebrow">Standards</p>
          <h2 className="section-heading mb-10">Built for Operational Excellence</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {standards.map(s => (
              <div key={s.title} className="bg-thl-dark3 border border-thl-border rounded-xl p-6 hover:border-thl-red/30 transition-all">
                <div className="text-3xl mb-4">{s.ico}</div>
                <h3 className="text-white font-bold text-base mb-2">{s.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAStrip
        headline="See Our Facilities in Person"
        sub="Book a guided tour and let our team walk you through our capabilities."
        btn1="Book a Tour →"
        onBtn1Click={() => setTourOpen(true)}
        btn2="Get a Quote"
        btn2Path="/contact"
      />
      <Footer />
    </div>
  );
}
